import classnames from 'clsx'
import {
  Navigation,
  Autoplay,
  Pagination,
  A11y,
  Keyboard,
  Mousewheel
} from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useMount } from '@hooks'
import { StyledWrap } from './style'
import 'swiper/css/navigation'
import './swiper.css'

const SwiperSlider = ({
  options,
  navStyle = 1,
  navPosition = 1,
  dotStyle = 2,
  dotPosition = 1,
  paginationTop,
  shadowSize,
  children,
  className,
  vAlign,
  opacityStyle,
  waitForMount = true
}) => {
  if (waitForMount) {
    const mounted = useMount()
    if (!mounted) return null
  }
  const sliderOptions = {
    modules: [Navigation, Pagination, A11y, Autoplay, Keyboard, Mousewheel],
    slidesPerView: 3,
    spaceBetween: 30,
    loop: false,
    keyboard: { enabled: true },
    mousewheel: true,
    watchSlidesProgress: true,
    autoHeight: true,
    ...options,
    navigation: !!options?.navigation,
    pagination: options?.pagination ? { clickable: true } : false,
    autoplay: options?.autoplay
      ? options?.autoplay?.delay
        ? options.autoplay
        : {
            delay: 2500,
            disableOnInteraction: true
          }
      : false
  }
  return (
    <StyledWrap
      className={classnames(className, 'swiper-wrap')}
      $navStyle={navStyle}
      $navPosition={navPosition}
      $dotStyle={dotStyle}
      $dotPosition={dotPosition}
      $shadowSize={shadowSize}
      $paginationTop={paginationTop}
      $vAlign={vAlign}
      $opacityStyle={opacityStyle}
    >
      <Swiper {...sliderOptions}>{children}</Swiper>
    </StyledWrap>
  )
}

export { SwiperSlide }

export default SwiperSlider
